module.exports = __webpack_public_path__ + "img/logo_salesforce.271f382e.png";